import React, { useState } from 'react';
import { BoutonIcone, useTel } from '../kit/BarreIcones';
// LOT 55 · E3 · sur téléphone, les filtres connus deviennent une icône de la collection
const AUTO_ICO = { Lieu: 'lieu', Service: 'couverts', Carte: 'toque', Famille: 'carton', Fournisseur: 'camion', Pôle: 'equipe', Poste: 'equipe', Catégorie: 'etiquette', Zone: 'lieu', Canal: 'partager' };
import { Check, ChevronDown } from 'lucide-react';
import { IgSheet } from './IgSheet';

const COULEURS = ['#E8823A', '#5B8FD6', '#3E9B6B', '#C2410C', '#8B5CF6', '#D9A400'];

/* LOT 9.7 · petit sélecteur « Lieu · Tous ▾ » / « Carte · Toutes ▾ » · demi-feuille avec coche · noir quand un filtre est actif */
export const ChoixFiltre = ({ label, tous, options = [], actif = null, onChoix, testId, titre, icone: icone0 }) => {
  const tel = useTel();
  const icone = icone0 || (tel ? AUTO_ICO[label] : null);
  const [open, setOpen] = useState(false);
  const courant = options.find((o) => o.id === actif);
  const coul = (i) => options[i]?.couleur || COULEURS[i % COULEURS.length];
  const idx = options.findIndex((o) => o.id === actif);
  const choisir = (id) => { setOpen(false); onChoix?.(id); };
  return (
    <>
      {icone ? <BoutonIcone ico={icone} label={courant ? `${label} · ${courant.name}` : `${label} · ${tous}`} actif={!!courant} onClick={() => setOpen(true)} testId={testId} /> /* LOT 55 · G1 · filtre en icône */ :
      <button type="button" className={`m-choix${courant ? ' is-actif' : ''}`} onClick={() => setOpen(true)} data-testid={testId} data-keepicon="">
        <i className="m-choix-dot" style={{ background: courant ? coul(idx) : '#B8B0A6' }} />
        <span>{label} · {courant ? courant.name : tous}</span><ChevronDown size={14} />
      </button>}
      <IgSheet open={open} onClose={() => setOpen(false)} title={titre || `Quel${label === 'Carte' ? 'le carte' : ' lieu'} ?`} kicker="Filtrer" half testId={`${testId}-sheet`}>
        <div className="m-list">
          <button type="button" className="m-row m-choix-l" onClick={() => choisir(null)} data-testid={`${testId}-tous`}><i className="m-choix-dot" style={{ background: '#B8B0A6' }} /><b>{tous}</b>{!courant && <Check size={18} />}</button>
          {options.map((o, i) => <button key={o.id} type="button" className="m-row m-choix-l" onClick={() => choisir(o.id)} data-testid={`${testId}-${o.id}`}><i className="m-choix-dot" style={{ background: coul(i) }} /><b>{o.name}</b>{actif === o.id && <Check size={18} />}</button>)}
        </div>
      </IgSheet>
    </>
  );
};
